<template>
  <div :class="$style.list">
    <button class="btn sm" @click="getLessons()">Refresh List</button>
    <input :class="$style.search" type="search" v-model="query" @input="search(query)" placeholder="Search">
    <ul v-if="query">
      <li v-for="(item, index) in results" v-on:click="selectItem(item.id)" :class="{[$style.category]: (item.type == 'category')}">
        <span class="title">{{ item.title }}</span>
      </li>
    </ul>
    <ul v-if="!query">
      <list-item v-for="item in items" :training="item" :key="item.id" :class="{[$style.category]: (item.type == 'category')}"></list-item>
    </ul>
  </div>
</template>

<script>
  import database from '../../../database'
  import constants from '../../../constants'
  import _filter from 'lodash/filter'
  import _each from 'lodash/each'
  import listItem from './listItem'
  import lib from './lib'

  export default {
    name: 'training',
    components: {
      listItem
    },
    data () {
      return {
        selected: {},
        loading: true,
        query: '',
        results: []
      }
    },
    computed: {
      srcData () {
        return this.$store.state.training.lessonsSrc
      },
      items () {
        return this.$store.state.training.lessons
      }
    },
    methods: {
      getLessons () {
        var vc = this
        database
          .get(['academy', 'lessons'], ['type', 'index', 'category'])
          .then(function (data) {
            vc.$store.commit(constants.SET_LESSONS_SRC, data)
            vc.$store.commit(constants.SET_LESSONS, vc.buildCatTree(data, 'academy'))
            vc.loading = false
            vc.$toasted.show('Lessons have been loaded from the database', {
              duration: 3000,
              className: 'toasty'
            })
          })
      },
      search (query) {
        this.results = _filter(this.srcData, function (n) {
          var props = []
          _each(n, function (val, key) {
            if (typeof val === 'string' && val.includes(query)) {
              props.push(val)
            }
          })
          return props.length
        })
      },
      buildCatTree (data, cat) {
        return lib.buildCatTree(data, cat)
      },
      selectItem (id) {
        this.$router.push({path: `/training/${id}`})
      }
    },
    mounted () {
      console.log('Loading training modules')
      this.getLessons()
    }
  }
</script>

<style lang="scss" module>
  .list {
    ul {
      padding: 0;
      list-style-type: none;
      li {
        display: block;
        padding: 3px 6px;
        margin-bottom: 3px;
        cursor: pointer;
      }
    }
    .search {
      display: block;
      width: 100%;
      padding: 0.7em;
      font-size: 1em;
      border: 1px solid #DDD;
      margin-bottom: .5em;
      border-radius: 3px;
      box-shadow: inset 0 1px 3px rgba(0,0,0,0.06);
      outline: none;

      &:focus {
        border-color: #2196F3;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Training/list/index.vue